module.exports = __webpack_public_path__ + "img/chevron_up_light.b18461f1.svg";